import TypeManager from "./TypeManager";

export default function ExpenseTypes() {
  return (
    <TypeManager
      title="Expense Types"
      subtitle="Manage custom expense categories."
      apiPath="ExpenseTypes"
      nameField="typeName"
      idField="id"
      feature="custom_expense_categories"
    />
  );
}
